import React from 'react';
import { Link } from 'react-router-dom';

const WarrantySection: React.FC = () => {
  return (
    <section className="bg-white py-20">
      <div className="container-custom">
        <div className="bg-primary/5 rounded-xl p-8 md:p-12 relative overflow-hidden">
          <div className="absolute right-0 top-0 bottom-0 w-1/3 bg-primary/10 -skew-x-12 transform translate-x-20 hidden lg:block"></div>
          
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
            <div className="lg:col-span-3 relative z-10">
              <h2 className="text-3xl font-serif mb-6">Our 2-10 Warranty</h2>
              <p className="text-gray-700 mb-6">
                We stand behind the quality of our homes with our comprehensive 2-10 Home Buyers Warranty. 
                This warranty provides ten years of coverage for your new home, with two years for workmanship 
                and materials, and eight years for structural defects.
              </p>
              <p className="text-gray-700 mb-8">
                Trust us to take care of any issues with our backed insurance policy and dedicated customer service team. 
                Your peace of mind is our priority.
              </p>
              <Link to="/warranty" className="btn btn-primary">
                Learn More
              </Link>
            </div>
            
            <div className="lg:col-span-2 flex items-center justify-center relative z-10">
              <div className="bg-white rounded-lg shadow-lg p-8 text-center w-full">
                <div className="text-5xl font-bold text-primary mb-4">2-10</div>
                <div className="text-2xl font-medium text-gray-800 mb-2">Year Warranty</div>
                <p className="text-gray-600">
                  Protection for your investment and peace of mind for your family.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WarrantySection; 